import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Paper, Grid, Stack, Button, Typography } from '@mui/material';
import { Add, AdminPanelSettings } from '@mui/icons-material';
import '../../App.css';
import Popup from '../Popup';
import Notification from '../Notification';
import AccessRolesTable from '../table-data/AccessRolesTable';
import AccessRoleForm from './AccessRoleForm';

function ViewAccessRoles() {
  const isAdmin = useSelector((state) => state.auth.activeUserRole) === 'ADMIN';
  const [popup, setPopup] = useState({ open: false, role: null });
  const [reloadKey, setReloadKey] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });

  const setOpenPopup = (open) => setPopup((prev) => ({ ...prev, open }));

  const handleSuccess = (message) => {
    setOpenPopup(false);
    setReloadKey((prev) => prev + 1);
    if (message) setNotify({ isOpen: true, message, type: 'success' });
  };

  if (!isAdmin) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px' }}>
        <Typography variant="h6" color="error">
          Only company admins can access Access Roles.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '10px', padding: '30px' }}>
      <Paper elevation={0} sx={{ width: '1000px' }}>
        <Grid className="form-title" style={{ marginBottom: '-60px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              Access Roles
            </Typography>
          </Grid>
          <Grid item>
            <AdminPanelSettings sx={{ marginLeft: '-30px', width: 40, height: 40, color: '#344D67' }} />
          </Grid>
        </Grid>
        <Stack spacing={2} sx={{ margin: '30px' }}>
          <Stack display="flex" sx={{ alignItems: 'flex-end' }}>
            <Button
              style={{ width: '150px', marginBottom: '-10px', marginTop: '10px' }}
              className="form-btn"
              variant="outlined"
              color="success"
              onClick={() => setPopup({ open: true, role: null })}
              startIcon={<Add sx={{ width: 24, height: 24 }} style={{ marginRight: '-8px' }} />}
              sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
            >
              Add Access Role
            </Button>
          </Stack>

          <AccessRolesTable reloadKey={reloadKey} onEdit={(role) => setPopup({ open: true, role })} />
        </Stack>

        <Popup title={popup.role ? 'Edit Access Role' : 'Add Access Role'} openPopup={popup.open} setOpenPopup={setOpenPopup}>
          <AccessRoleForm initialData={popup.role} onSuccess={handleSuccess} />
        </Popup>
      </Paper>
      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
}

export default ViewAccessRoles;
